import React, { useCallback, useState, useEffect } from 'react'
import {
	BarChart,
	Bar,
	CartesianGrid,
	XAxis,
	YAxis,
	Legend,
	Tooltip
} from "recharts";
import appUrl from '../../appUrl';
import { toast } from 'react-toastify';
import { GrOverview } from "react-icons/gr";

const TableUserProvider = () => {
	const AppUrl = appUrl();
	const [ dataLoading, setDataLoading ] = useState(false)
    const [ data, setData ] = useState([])

	const currentMonth = new Date().getMonth();

	const fetchMonthlyRegistrations = useCallback( async (year) => {
		if(dataLoading) return;
		
		const token = localStorage.getItem("token");
  
		try {
		  setDataLoading(true);
  
		  const response = await fetch(`${AppUrl}/dashboard/monthly-registrations?year=${year}`, {
			method: "GET",
			headers: {
			  Authorization: `Bearer ${token}`,
			},
		  });
  
		  if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		  }
	  
		  const data = await response.json();
	  
		  if (!data.status) {
			throw new Error(data.message || "Some error occurred!");
		  }
  
			setData(
				data.data.map((item, index) => ({
				...item,
				customers: index <= currentMonth ? item.customers : null,
				providers: index <= currentMonth ? item.providers : null,
			})));
  
		} catch (error) {
			console.error(error);
			toast.error(error.message || "Some error occurred!");
		} finally {
		  setDataLoading(false)
		}
	  }, [AppUrl])
  
	  useEffect(() => {
		fetchMonthlyRegistrations()
	  }, [fetchMonthlyRegistrations])

	return (
		<div className='py-3 px-3 border shadow-sm' style={{ width: 'fit-content', borderRadius: '25px'}}>
            <h4 className="mb-4">{`New Traffic: ${new Date().getFullYear()}`}</h4>
			<BarChart width={670} height={380} data={data}>
                <CartesianGrid stroke="#ccc" strokeDasharray="3 3" vertical={false} />
				<XAxis dataKey="month" />
				<YAxis />
				<Tooltip />
				<Legend />
				<Bar dataKey="customers" fill="#0088FE" name="Customers" />
				<Bar dataKey="providers" fill="#00C49F" name="Providers" />
			</BarChart>
			<div className='flex justify-content-end py-2 align-items-center'>
				<div className='cursor-pointer p-2 border border-black rounded'>
					<span className='mx-1'>Overview</span>
					<span className='text-lg'><GrOverview/></span>
				</div>
			</div>
		</div>
	);
};

export default TableUserProvider;
